import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class PartnerService {
  private env: any;
  private apiURL: string = '';
  private apiURLNew: string = '';

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.env = this.appConfig.getEnvironmentNew();
    this.apiURLNew = this.appConfig.getEnvironmentNew().url;
  }

  getPartners() {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http.get(this.apiURL + '/api/Partner', requestOptions).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((res: any) => {
        return throwError(res.statusText);
      }),
    );
  }

  getPartnersV2(
    page,
    limit,
    search,
    fullsummary: boolean = false,
    status: string = '',
  ) {
    const headers = this.helpersService.getNewApiHeaders();
    //console.log(headers);
    return this.http
      .get(
        this.env.url +
        `/Bikeshops?code=${this.env.key}&page=${page}&limit=${limit}&search=${search}${fullsummary ? '&fullsummary=true' : ''}${status != '' ? '&status=' + status : ''}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnersCopyShop(
    page,
    limit,
    search
  ) {
    const headers = this.helpersService.getNewApiHeaders();
    //console.log(headers);
    return this.http
      .get(
        this.env.url +
        `/Bikeshops/CopyShops?code=${this.env.key}&page=${page}&limit=${limit}&search=${search}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerDetail(partnerId: string, getCollectionTimeSlots: boolean = false) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    if (partnerId == null || partnerId == undefined || partnerId == '') {
      partnerId = this.helpersService.getPartnerId();
    }
    if (partnerId == null || partnerId == undefined || partnerId == '') {
      return throwError('Partner ID is required');
    }
    return this.http
      .get(this.apiURL + '/api/Partner/' + partnerId, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerDetailCyclistPortal(partnerId: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });

    return this.http
      .get(this.apiURL + '/api/Partner/' + partnerId, {
        headers: headers
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerDetailV2(
    partnerId: string,
    getCollectionTimeSlots: boolean = false,
  ) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL +
        '/api/Partner/' +
        partnerId +
        '/' +
        getCollectionTimeSlots,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  savePartnerDetail(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/api/Partner/', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  savePartnerDetailV2(data: any, timeSlots: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/v2/Partner/',
        { partner: data, timeList: timeSlots },
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  saveImage(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/api/Partner/SaveImage', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  //New API to upload generic images, it returns the URL of the image
  uploadImage(data: any, partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Partner/Image/Upload/${partnerID}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getPartnerUsers(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(this.apiURL + '/api/Partner/' + partnerId + '/users', requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerSystemUsers(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL + '/api/Partner/' + partnerId + '/V2/SystemUsers',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerServiceTypesFull(partnerId: string, showFittings = false) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL +
        '/api/Partner/' +
        partnerId +
        '/V3/serviceTypes?ShowFittings=' +
        showFittings,
        requestOptions,
      )
      .pipe(
        map((res: any) =>
          res.sort((a, b) => {
            var aGroupName =
              a.GroupName && a.GroupName.length > 0 ? a.GroupName : 'XXXXXXXX'; //Want ungrouped at the bottom
            var bGroupName =
              b.GroupName && b.GroupName.length > 0 ? b.GroupName : 'XXXXXXXX'; //Want ungrouped at the bottom
            var aDescription = a.ServiceTypeDescription;
            var bDescription = b.ServiceTypeDescription;

            if (aGroupName == bGroupName) {
              return aDescription < bDescription
                ? -1
                : aDescription > bDescription
                  ? 1
                  : 0;
            } else {
              return aGroupName < bGroupName ? -1 : 1;
            }
          }),
        ),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerServiceTypesThirdPartyStatus(
    partnerId: string,
    showFittings = false,
  ) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL +
        '/api/Partner/' +
        partnerId +
        '/V4/serviceTypes?ShowFittings=',
        requestOptions,
      )
      .pipe(
        map((res: any) =>
          res.json().sort((a, b) => {
            var aGroupName =
              a.GroupName && a.GroupName.length > 0 ? a.GroupName : 'XXXXXXXX'; //Want ungrouped at the bottom
            var bGroupName =
              b.GroupName && b.GroupName.length > 0 ? b.GroupName : 'XXXXXXXX'; //Want ungrouped at the bottom
            var aDescription = a.ServiceTypeDescription;
            var bDescription = b.ServiceTypeDescription;

            if (aGroupName == bGroupName) {
              return aDescription < bDescription
                ? -1
                : aDescription > bDescription
                  ? 1
                  : 0;
            } else {
              return aGroupName < bGroupName ? -1 : 1;
            }
          }),
        ),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getJobCardServiceTypesDropDowns(partnerId: string, jobCardID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL +
        '/api/Partner/' +
        partnerId +
        '/serviceTypes?limited=true&jobcardID=' + jobCardID,
        requestOptions,
      )
      .pipe(
        map((res: any) =>
          res.sort((a, b) => {
            var aGroupName =
              a.GroupName && a.GroupName.length > 0 ? a.GroupName : 'XXXXXXXX'; //Want ungrouped at the bottom
            var bGroupName =
              b.GroupName && b.GroupName.length > 0 ? b.GroupName : 'XXXXXXXX'; //Want ungrouped at the bottom
            var aDescription = a.ServiceTypeDescription;
            var bDescription = b.ServiceTypeDescription;

            if (aGroupName == bGroupName) {
              return aDescription < bDescription
                ? -1
                : aDescription > bDescription
                  ? 1
                  : 0;
            } else {
              return aGroupName < bGroupName ? -1 : 1;
            }
          }),
        ),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerServiceTypesDropDowns(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL +
        '/api/Partner/' +
        partnerId +
        '/serviceTypes?limited=true',
        requestOptions,
      )
      .pipe(
        map((res: any) =>
          res.sort((a, b) => {
            var aGroupName =
              a.GroupName && a.GroupName.length > 0 ? a.GroupName : 'XXXXXXXX'; //Want ungrouped at the bottom
            var bGroupName =
              b.GroupName && b.GroupName.length > 0 ? b.GroupName : 'XXXXXXXX'; //Want ungrouped at the bottom
            var aDescription = a.ServiceTypeDescription;
            var bDescription = b.ServiceTypeDescription;

            if (aGroupName == bGroupName) {
              return aDescription < bDescription
                ? -1
                : aDescription > bDescription
                  ? 1
                  : 0;
            } else {
              return aGroupName < bGroupName ? -1 : 1;
            }
          }),
        ),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerTechnicians(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL + '/api/Partner/' + partnerId + '/technicians',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerTechniciansV2(partnerIds: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL + '/api/Partner/' + partnerIds + '/techniciansV2',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  updateTechnicianPOSEmployee(partnerId: string, data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(
        this.apiURL + '/api/Partner/' + partnerId + '/technicianemployeelink',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  updateTechnicianSortOrder(partnerId: string, data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(
        this.apiURL + '/api/Partner/' + partnerId + '/techniciansortorder',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerOpenJobCards(partnerId: string, FromDate: string, ToDate: string) {
    let body = { ID: partnerId, FromDate: FromDate, ToDate: ToDate };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(
        this.apiURL + '/api/Partner/GetOpenJobcardsMinimum',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerOpenJobCardsV2(
    partnerId: string,
    fromDate: string,
    toDate: string,
  ) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Technician/Calendar/Data?code=${this.env.key}&PartnerID=${partnerId}&FromDate=${fromDate}&ToDate=${toDate}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerJobCardsMinimum(partnerId: string, StatusID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL +
        '/api/Partner/' +
        partnerId +
        '/JobcardsMinimum/' +
        StatusID,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerJobCardsMinimumV2(
    partnerId: string,
    StatusID: string,
    partners: string,
  ) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL +
        '/api/Partner/' +
        partnerId +
        '/JobcardsMinimumV2/' +
        StatusID +
        '/' +
        partners,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerJobCardsMinimumV3(
    partnerId: string,
    statusId: string,
    partners: string,
  ) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/V3/Portal/Partner/${partnerId}/Jobcards/${statusId}/${partners}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  searchCalendarEvents(partnerId: string, FromDate: string, ToDate: string) {
    let body = { ID: partnerId, FromDate: FromDate, ToDate: ToDate };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(
        this.apiURL + '/api/Partner/SearchCalendarEvents',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getNextJobcardID(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL + '/api/Partner/' + partnerId + '/GetNextJobcardID',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getNextAvailableDatesForService(partnerId: string, serviceTypes: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    let body = {
      ID: partnerId,
      ServiceTypeID: 0,
      ServiceTypes: serviceTypes,
      FromDate: new Date(),
      NoOfDates: 10,
    };
    //TODO Where does ServiceTypeID come from???
    return this.http
      .post(
        this.apiURL + '/api/Partner/GetNextAvailableDatesForService',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  scheduleService(request: any, sendComms = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL +
        '/api/Partner/v3/ScheduleService?SendCommunication=' +
        sendComms,
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  scheduleWorkshopService(request: any, sendComms = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL +
        '/api/Partner/v4/ScheduleService?SendCommunication=' +
        sendComms,
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getChecklistConfig(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + `/api/Partner/${partnerId}/ChecklistConfig`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getChecklistConfigAll(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + `/api/Partner/${partnerId}/ChecklistConfigAll`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  saveChecklistConfigItem(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Partner/SaveChecklistConfig`,
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getChecklistGroups(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + `/api/Partner/${partnerId}/ChecklistGroups`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  saveChecklistGroup(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Partner/SaveChecklistGroup`,
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  saveServiceType(request: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/SaveServiceType',
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  saveServiceTypeV2(request: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/SaveServiceTypeV2',
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  linkServiceTypeChecklist(request: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/LinkServiceTypeChecklist',
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  unlinkServiceTypeChecklist(request: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/UnLinkServiceTypeChecklist',
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getSkusLinkedToServiceType(partnerId: string, serviceTypeId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        `/api/Partner/${partnerId}/LinkedToQuote/${serviceTypeId}`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  setServiceSKU(request) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL +
        `/api/Partner/${this.helpersService.getPartnerId()}/setServiceSKU`,
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  setNewServiceSKU(request) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL +
        `/api/Partner/${this.helpersService.getPartnerId()}/setNewServiceSKU`,
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  setServiceCategory(categories) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL +
        `/api/Partner/${this.helpersService.getPartnerId()}/changCategory`,
        categories,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  linkSkuToServiceType(request: any, partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Partner/${partnerId}/LinkedToQuote`,
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  unlinkSkuFromServiceType(request: any, partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Partner/${partnerId}/UnLinkedToQuote`,
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  linkCyclistToPartner(partnerId: string, CyclistId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        `/api/Partner/${partnerId}/LinkCyclist/${CyclistId}/Rating/0`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getMessageTemplates(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + `/api/Partner/${partnerId}/MessageTemplates`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getMessageTemplatesV2(partnerId: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/Stores/${partnerId}/MessageTemplates?code=` + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }



  getMessageTemplate(partnerId: string, templateId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + `/api/Partner/${partnerId}/MessageTemplate/${templateId}`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getMessageTemplateV2(partnerId: string, templateId: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/Stores/${partnerId}/MessageTemplate/${templateId}?code=` + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }


  saveMessageTemplate(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Partner/SaveMessageTemplate`,
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  saveMessageTemplateV2(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Stores/${data.PartnerID}/MessageTemplate?code=` + this.env.key, data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRoles() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(this.env.url + '/Users/Roles?code=' + this.env.key, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceTypeCollections(id) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + `/api/Partner/${id}/ServiceTypes/Collections`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  deleteCollectionTime(id) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Partner/Delete/CollectionTime/${id}`,
        {},
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getOrganisationShortCode(id) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + `/api/Partner/${id}/getOrganisationShortCode`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  updateServiceTypeGroupOrder(partnerID, categories) {
    let data = { PartnerID: partnerID, Groups: categories };

    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Partner/UpdateServiceTypeGroupOrder`,
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getWalkin(
    PartnerID,
    WalkinName,
    newWalkingName,
    newWalkinPhone,
    newWalkinEmail,
  ) {
    var data = {
      WalkinName: WalkinName,
      NewWalkinName: newWalkingName,
      NewWalkinPhone: newWalkinPhone,
      NewWalkinEmail: newWalkinEmail,
    };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Partner/${PartnerID}/GetWalkInAccountList`,
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  testURL(url) {
    return this.http.get(url).pipe(
      map((res: any) => res),
      catchError((res: any) => {
        return throwError(res);
      }),
    );
  }

  getWorkToDo(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL + '/api/Partner/webhooks/' + partnerId + '/work',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getExternalIntegrationOptions(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL +
        '/api/Partner/' +
        partnerId +
        '/GetExternalIntegrationOptions',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  tourComplete(partnerID) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Partner/${partnerID}/TourComplete`,
        {},
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  submitHelpRequest(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/v4.0/SubmitHelpRequest?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getLightspeedRedirectInfo(AccountID, ShopID, SaleID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/LightspeedRedirect/${AccountID}/${ShopID}/${SaleID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getVendRedirectInfo(vendSaleID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/VendRedirect/${vendSaleID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceRedirectInfo(ServiceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/ServiceRedirect/${ServiceID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  sendBrowserNotificationData(sub: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/SetBrowserNotificationData?code=${this.env.key}`,
        sub,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addSMSCredits(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/AddSMSCredits?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  extendTrial(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/ExtendTrial?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  savePartnerWidgetSettings(partnerID: any, data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/2021-01/partner/widget/settings/${partnerID}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  copyStoreSettings(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshops/Copy?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  copyStoreSettingsV2(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshops/CopyV2?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          this.errorHandler.showError(res,
            "Failed to copy shop details");

          return throwError(res.json());
        }),
      );
  }

  getPartnerWidgetSettings(partnerIdentifier) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        '/2021-01/partner/widget/settings/' +
        partnerIdentifier +
        '?code=' +
        this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getPartnerSLAServices(partnerIdentifier) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        '/partner/' +
        partnerIdentifier +
        '/sla/services?code=' +
        this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getPartnerParents() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + '/Franchise/GetPartnerParents?code=' + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  bulkUpdateServiceStatuses(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + '/Bikeshop/Status/BulkUpdate?code=' + this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postLinkFranchiseToStores(franchiseId, storeIds) {
    let data = { PartnerParentId: franchiseId, SelectedStoresIds: storeIds };

    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        '/Franchise/PostLinkShopsToPartnerParent?code=' +
        this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getFranchiseDetails(franchiseIdentifier) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        '/Franchise/GetPartnerParent/' +
        franchiseIdentifier +
        '?code=' +
        this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  postCreateNewFranchise(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        '/Franchise/PostCreatePartnerParent?code=' +
        this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  postUpdateFranchise(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        '/Franchise/PostUpdatePartnerParent?code=' +
        this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getPartnerDataCyclistPlatform(ServiceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.apiURLNew +
        `/Service/PatnerData/${ServiceID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getWaiverConfig(partnerID: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.apiURLNew +
        `/Workshop/${partnerID}/WaiverConfig?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res);
        }),
      );
  }

  updateWaiverConfig(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.apiURLNew + `/Workshop/WaiverConfig?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res);
        }),
      );
  }

  getPartnerSubscriptionInformation(partnerID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/Store/${partnerID}/StatusDetail?code=` + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updatePartnerSubscriptionInformation(partnerID: number, data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Store/${partnerID}/StatusDetail?code=` + this.env.key, data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getCopyShopConfig() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Copy/GetCopyStoreConfig?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  getAllLinkedPartners(partnerID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/Partner/${partnerID}/LinkedPartners?code=` + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }


  savePartnerDetails(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    var partnerID = this.helpersService.getPartnerId();
    return this.http
      .put(
        this.env.url + `/Store/${partnerID}/Details?code=` + this.env.key, data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getPartnerType(partnerId: number) {
    return this.http
      .get(
        this.env.url + `/partner/${partnerId}/type?code=` + this.env.key, {}
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
}
